var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-table-ex',{attrs:{"url":_vm.url,"tableColumns":_vm.tableColumns,"isSimple":true},on:{"isError":function($event){_vm.isError = $event},"isLoading":function($event){_vm.isLoading = $event},"rowClicked":function($event){return _vm.showDetails(_vm.selectedRow = $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/paywall/sessions/sections/Institution.vue